module.exports = __webpack_public_path__ + "img/red.650a32f4.webp";